import { combineReducers } from "redux";
import accountNumbersSlice from "./accountManagement/accountNumbersSlice";
import businessUnitsSlice from "./accountManagement/businessUnitsSlice";
import clientsSlice from "./accountManagement/clientsSlice";
import distributorsSlice from "./accountManagement/distributorsSlice";
import requestSlice from "./accountManagement/requestsSlice";
import resellersSlice from "./accountManagement/resellersSlice";
import usersSlice from "./accountManagement/usersSlice";
import allRolesSlice from "./allRolesSlice";
import permissionSlice from "./permissionSlice";
import roleSlice from "./roleSlice";

const accountManagementReducer = combineReducers({
	allRoles: allRolesSlice,
	permissions: permissionSlice,
	userState: usersSlice,
	roles: roleSlice,
	clients: clientsSlice,
	businessUnits: businessUnitsSlice,
	distributors: distributorsSlice,
	resellers: resellersSlice,
	accountNumbers: accountNumbersSlice,
	requests: requestSlice,
});

export default accountManagementReducer;
